import { motion } from 'framer-motion';

export default function AboutProject() {
  return (
    <div className="relative py-20 overflow-hidden bg-gradient-to-b from-[#0A0A0F] via-[#0F1520] to-[#0A0A0F]">
      {/* Background Effects */}
      <div className="absolute inset-0">
        {/* Top blend gradient */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(0,100,150,0.15),rgba(0,0,0,0)_50%)]" />
        
        {/* Center ambient light */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(0,100,150,0.1),rgba(0,0,0,0)_70%)]" />
        
        {/* Bottom blend gradient */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_100%,rgba(0,100,150,0.15),rgba(0,0,0,0)_50%)]" />
        
        {/* Subtle grid overlay */}
        <div className="absolute inset-0 bg-grid-pattern opacity-10" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-center">
          {/* Text Content */}
          <div className="w-full max-w-4xl relative mb-16">
            {/* Decorative Element */}
            <div className="absolute -left-4 top-0 w-1 h-24 bg-gradient-to-b from-red-500/80 to-transparent" />
            
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-8"
            >
              <h2 className="text-5xl md:text-7xl font-bold code-mono leading-tight">
                Choose Your Element,
                <br />
                <span className="text-red-500">Conquer</span>{" "}
                <span className="text-orange-400">the</span>{" "}
                <span className="text-blue-400">Tournament!</span>
              </h2>
            </motion.div>

            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="text-lg text-gray-300 code-mono mb-8 leading-relaxed"
            >
              Dive into Rumble—a thrilling NFT experience where luck and strategy intertwine. 
              Assemble your team of elemental{" "}
              <motion.span 
                className="text-red-500 font-bold"
                whileHover={{ scale: 1.1 }}
                style={{ display: 'inline-block' }}
              >
                champions
              </motion.span>
              —
              <motion.span 
                className="text-red-500 font-bold"
                whileHover={{ scale: 1.1 }}
                style={{ display: 'inline-block' }}
              >
                Fire
              </motion.span>
              ,{" "}
              <motion.span 
                className="text-blue-400 font-bold"
                whileHover={{ scale: 1.1 }}
                style={{ display: 'inline-block' }}
              >
                Water
              </motion.span>
              ,{" "}
              <motion.span 
                className="text-emerald-400 font-bold"
                whileHover={{ scale: 1.1 }}
                style={{ display: 'inline-block' }}
              >
                Earth
              </motion.span>
              , and{" "}
              <motion.span 
                className="text-purple-400 font-bold"
                whileHover={{ scale: 1.1 }}
                style={{ display: 'inline-block' }}
              >
                Air
              </motion.span>
              —and navigate a knockout tournament that challenges your wits and tactics.
            </motion.p>
          </div>

          {/* Character Image */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="w-full max-w-5xl relative"
          >
            {/* Glow Effect */}
            <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,100,150,0.15)] via-transparent to-[rgba(0,100,150,0.15)] rounded-3xl blur-3xl" />
            
            <motion.img 
              src="/characters/image 1.png" 
              alt="Character Lineup"
              className="w-full h-auto relative z-10 drop-shadow-2xl"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
} 